var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8777)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8777",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8777)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2812 10.125L13.3437 7.0625C13.375 7.0312 13.4375 7 13.5 7C13.5625 7 13.5938 7.0312 13.6563 7.0625L14.8125 8.2187C14.8437 8.25 14.875 8.3125 14.875 8.375C14.875 8.4375 14.8437 8.4688 14.8125 8.5313L10.4375 12.9063C10.4063 12.9375 10.3437 12.9688 10.2812 12.9688C10.2187 12.9688 10.1875 12.9375 10.125 12.9063L7.6875 10.4688C7.6562 10.4375 7.625 10.375 7.625 10.3125C7.625 10.25 7.6562 10.2187 7.6875 10.1562L8.8437 9C8.875 8.9688 8.9375 8.9375 9 8.9375C9.0625 8.9375 9.0937 8.9688 9.1562 9L10.2812 10.125ZM7.4062 13.625H15.75C15.875 13.625 15.9687 13.6562 16.0312 13.75C16.125 13.8437 16.1562 13.9375 16.1562 14.0313V16.125H7V14.0313C7 13.9063 7.0312 13.8125 7.125 13.75C7.1875 13.6875 7.2812 13.625 7.4062 13.625ZM14.4688 14.4688V14.875H15.3125V14.4688H14.4688Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8777",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/Saved.496d4df17fae7cf97e73f7ea3a4b27ad.svg";
export { ForwardRef as ReactComponent };